"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DecimalGeneralHandler", {
    enumerable: true,
    get: function() {
        return DecimalGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _handlerUtils = require("../../utils/handlerUtils");
const _generic = require("~/db/field-handler/handlers/generic");
let DecimalGeneralHandler = class DecimalGeneralHandler extends _generic.GenericFieldHandler {
    async verifyFilter(filter, column) {
        const supportedOperations = [
            'gb_eq',
            'gb_null',
            'eq',
            'neq',
            'blank',
            'notblank',
            'is',
            'isnot',
            'gt',
            'lt',
            'gte',
            'lte',
            'ge',
            'le',
            'in',
            'like',
            'nlike',
            'empty',
            'notempty',
            'null',
            'notnull'
        ];
        if (!supportedOperations.includes(filter.comparison_op)) {
            return {
                isValid: false,
                errors: [
                    `Operation ${filter.comparison_op} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        if (!(typeof filter.value === 'undefined' || filter.value === null || typeof filter.value === 'number' || (0, _nocodbsdk.ncIsNumber)(Number(filter.value)) || filter.comparison_op === 'in' && (Array.isArray(filter.value) || typeof filter.value === 'string'))) {
            return {
                isValid: false,
                errors: [
                    `Value ${filter.value} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        return {
            isValid: true
        };
    }
    async parseUserInput(params) {
        if (!(0, _nocodbsdk.ncIsUndefined)(params.value) && !(0, _nocodbsdk.ncIsNull)(params.value)) {
            const numberValue = Number(params.value);
            if (!(0, _nocodbsdk.ncIsNumber)(numberValue)) {
                _catchError.NcError.invalidValueForField({
                    value: params.value,
                    column: params.column.title,
                    type: params.column.uidt
                });
            }
            return {
                value: numberValue
            };
        }
        return {
            value: params.value
        };
    }
    async filterBlank(args, _rootArgs, _options) {
        const { sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.whereNull(sourceField);
            }
        };
    }
    async filterNotblank(args, _rootArgs, _options) {
        const { sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.whereNotNull(sourceField);
            }
        };
    }
    async filterNeq(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    qb.where((nestedQb)=>{
                        nestedQb.whereNotNull(sourceField);
                    });
                } else {
                    qb.where((nestedQb)=>{
                        nestedQb.where(knex.raw('?? != ?', [
                            sourceField,
                            val
                        ])).orWhereNull(sourceField);
                    });
                }
            }
        };
    }
};
